import { httpClient } from "@coworker/http-client";
import CloseReason from "@coworker/apprestructured/src/task-management/types/CloseReason";

export async function getAllCloseReasons() {
  return httpClient.tasks.get<CloseReason[]>("/close-reasons");
}
